import { getIsJobLaborTrackingEnabled } from 'lib/selectors/getIsJobLaborTrackingEnabled';
import { getCurrentOperator } from 'lib/selectors/getCurrentOperator';
import { createSelector } from 'reselect';

/**
 * Selector to get whether the operator selection modal/dropdown is open
 * @param {Object} state - Redux state object
 * @returns {boolean} True if the operator selection is open, false otherwise
 */
export const getSelectOperatorOpen = (state) => {
  return state?.selectOperator?.open;
};

/**
 * Selector to get the list of available operators to select from
 * @param {Object} state - Redux state object
 * @returns {Array} Array of operator options
 */
export const getSelectOperatorOptions = (state) => {
  return state?.selectOperator?.options;
};

/**
 * Memoized selector that determines if operator selection should be enabled
 * @param {Object} state - Redux state object
 * @returns {boolean} True if operator selection should be enabled:
 *   - Always enabled when not in ERP job control bar flow
 *   - Enabled in ERP flow only when there is no current operator selected
 */
export const getSelectOperatorEnabled = createSelector(
  [getIsJobLaborTrackingEnabled, getCurrentOperator],
  (isJobLaborTrackingEnabled, currentOperator) => {
    return !isJobLaborTrackingEnabled || !currentOperator;
  }
);
